module.exports = __webpack_public_path__ + "static/media/chat-red.d5872444.svg";